import type {
  AgentReleaseManifest,
  AgentReleaseRollout,
  AgentReleaseRolloutPreviewRequest,
  AgentReleaseRolloutPreviewResponse,
  AgentReleaseState,
  LatestAgentRelease,
  PutAgentReleaseRolloutRequest,
} from '@doneverse/shared'
import { api } from '../api/index.js'

export const agentReleaseService = {
  /**
   * The current agent installer plus a short-lived signed download URL. Backs
   * the /settings/activity-agent page. The URL expires in an hour, so this is
   * never cached for long — see latestAgentReleaseOptions' staleTime.
   */
  fetchLatestRelease: async (): Promise<LatestAgentRelease> => {
    return api.get('/v1/me/agent/latest-release').json<LatestAgentRelease>()
  },

  /** Admin view: stable manifest, rollout, versions and history. */
  fetchAdminState: async (): Promise<AgentReleaseState> => {
    return api.get('/v1/admin/agent-releases').json<AgentReleaseState>()
  },

  /** Dry-run of a rollout body: who it would reach. Writes nothing. */
  previewRollout: async (
    body: AgentReleaseRolloutPreviewRequest,
  ): Promise<AgentReleaseRolloutPreviewResponse> => {
    return api
      .post(body, '/v1/admin/agent-releases/rollout/preview')
      .json<AgentReleaseRolloutPreviewResponse>()
  },

  putRollout: async (body: PutAgentReleaseRolloutRequest): Promise<AgentReleaseRollout> => {
    return api.put(body, '/v1/admin/agent-releases/rollout').json<AgentReleaseRollout>()
  },

  promote: async (
    version: string,
  ): Promise<{ stable: AgentReleaseManifest; rollout: AgentReleaseRollout | null }> => {
    return api
      .post({ version }, '/v1/admin/agent-releases/promote')
      .json<{ stable: AgentReleaseManifest; rollout: AgentReleaseRollout | null }>()
  },
}
